<!-- Carousel Copyright 2022 Rebecca L Beaudet  -->
<script lang="ts">
  import { MAIN_BANNER } from '../language/constantContent';

  import { carouselItems } from '../language/pageContent';

  const getAlignment = (slideNumber: number): string => {
    return slideNumber < 3 ? ' text-start' : ' text-end';
  };
</script>

<div id="myCarousel" class="carousel slide" data-bs-ride="carousel">
  <div class="carousel-indicators">
    {#each carouselItems as item, i}
      <button
        type="button"
        data-bs-target="#myCarousel"
        data-bs-slide-to={i}
        class={!i ? 'active' : ''}
        aria-current={!i ? true : false}
        aria-label={`Slide ${i}`}
      />
    {/each}
  </div>
  <div class="carousel-inner">
    {#each carouselItems as item, i}
      <div
        class={`carousel-item${!i ? ' active' : ''}${
          i === 1 ? ' carousel-item-next' : ''
        }`}
      >
        <img
          src={item?.imgPath ? item.imgPath : MAIN_BANNER}
          alt={item?.altTxt ? item.altTxt : 'Company Banner'}
          aria-hidden="true"
          class="banner-img"
        />
        <div class="container">
          <div class={`carousel-caption${getAlignment(i)}`}>
            <h1 class="text-dark">{item.title}</h1>
            <p class="text-dark">{item.placeholder}</p>
            <!-- <p><a class="btn btn-lg btn-primary" href="#">{callToActionButton}</a></p> -->
          </div>
        </div>
      </div>
    {/each}
  </div>
  <button
    class="carousel-control-prev"
    type="button"
    data-bs-target="#myCarousel"
    data-bs-slide="prev"
  >
    <span class="carousel-control-prev-icon" aria-hidden="true" />
    <span class="visually-hidden">Previous</span>
  </button>
  <button
    class="carousel-control-next"
    type="button"
    data-bs-target="#myCarousel"
    data-bs-slide="next"
  >
    <span class="carousel-control-next-icon" aria-hidden="true" />
    <span class="visually-hidden">Next</span>
  </button>
</div>

<style>
  .bd-placeholder-img {
    font-size: 1.125rem;
    text-anchor: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
  }
  .banner-img {
    width: 100%;
    height: 100%;
    /* object-fit: cover; */
  }
</style>
